<nz-upload
  [nzFileList]="fileList"
  [nzMultiple]="multiple"
  [nzBeforeUpload]="beforeUpload"
  [nzShowUploadList]="{ showRemoveIcon: true ,showDownloadIcon: true}"
  [nzRemove]="handleRemove"
  (nzChange)="handleChange($event)"
  nzListType="picture"
>
  <button nz-button>
    <nz-icon nzType="upload"></nz-icon>
    Choose Images
  </button>
</nz-upload>